/* eslint-disable no-param-reassign */
import produce from 'immer';
import { GET_WORKFLOW_COMPONENTS } from 'src/actions/typesActions';

const initialState = {
  dispatchWorkflowComponents: []
};

const dispatchWorkflowReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_WORKFLOW_COMPONENTS: {
      const dispatchWorkflowComponents = action.payload;

      return produce(state, (draft) => {
        draft.dispatchWorkflowComponents = dispatchWorkflowComponents;
      });
    }

    default: {
      return state;
    }
  }
};

export default dispatchWorkflowReducer;
